import { render, staticRenderFns } from "./BoxPhoto.vue?vue&type=template&id=5d60d6aa&scoped=true"
import script from "./BoxPhoto.vue?vue&type=script&lang=js"
export * from "./BoxPhoto.vue?vue&type=script&lang=js"
import style0 from "./BoxPhoto.vue?vue&type=style&index=0&id=5d60d6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60d6aa",
  null
  
)

export default component.exports